import { Stars } from 'components/front';
import { OpinionDto } from 'entities/opinion.dto';
import { SpecialistDto } from 'entities/specialist.dto';
import { PlaceDto } from 'entities/place.dto';
import React from 'react';

type Props = {
	opinions: OpinionDto[];
	// specialist: SpecialistDto | PlaceDto;
};

export const OpinionsTab: React.FC<Props> = ({ opinions }) => {
	return (
		<>
			{opinions && opinions.length === 0 && (
				<div className='text-gray-500 text-sm'>Brak wystawionych opinii</div>
			)}
			{opinions?.map((el: OpinionDto, i: Number) => {
				return (
					<>
						<div>
							<div
								className='my-2 p-2 text-sm rounded-lg text-gray-500 bg-blue-50'
								key={`${i}`}
							>
								<div className='flex items-center'>
									<div className='pb-1'>
										<Stars stars={el.rating} opinions={0} />
									</div>
									<span className='px-2'>
										<strong>
											{el.reservation?.service ?? el.reservation?.event?.name}{' '}
										</strong>
										{' - '}
										<b>{el.user.first_name}</b>
									</span>
								</div>
								{!!el.content && <i>{el.content}</i>}
								{!!el.opinion_responses[0] && (
									<div
										className='mt-2 ml-16 p-2 text-sm rounded-lg text-gray-500 bg-gray-50'
										key={`${i}`}
									>
										<strong>
											{el.specialist.shown_name}
											{': '}
										</strong>
										<i>{el.opinion_responses[0].content}</i>
									</div>
								)}
							</div>
						</div>
					</>
				);
			})}
		</>
	);
};
